module.exports = __webpack_public_path__ + "static/media/6.22e39788.jpg";